export default "__VITE_ASSET__DefJ_Ke6__"